// extracted by mini-css-extract-plugin
export default {"p_content":"_8fec03135b"};